import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { AuthCubit } from "../blocs/auth/AuthBloc";
import { AuthState } from "../blocs/auth/authStates";
import { IBlogDetailsCubit } from "../blocs/blog/BlogDetailsBloc";
import { BlogState } from "../blocs/blog/blogStates";
import useCubit from "../blocs/hooks";

interface CommentFormProps {
    cubit: IBlogDetailsCubit;
}

const CommentForm: React.FC<CommentFormProps> = ({ cubit }) => {
    const [commentText, setCommentText] = useState<string>('');
    const blogDetailsState = useCubit<BlogState>(cubit);
    const authState = useCubit<AuthState>(AuthCubit.getInstance());

    return <div
        style={{
            paddingBottom: 4,
            display: "flex",
            flexDirection: "row",
        }}
    >
        {
            authState.state === 'LOGGEDIN' && <>
                <Form.Control type="text" placeholder="Write your comment here..." value={commentText} onChange={(event) => {
                    setCommentText(event.target.value);
                }} />
                <div style={{ padding: 4 }} />
                <Button variant="outline-dark" disabled={commentText.length === 0 && blogDetailsState.state !== 'LOADED'} onClick={() => {
                    cubit.addComment(commentText);
                    setCommentText('');
                }}>Post</Button>
            </>
        }
        {
            (authState.state !== 'LOGGEDIN') && <>
                <p>Please sign in first to comment</p>
            </>
        }

    </div>

}

export default CommentForm;